export const calendarModals = {
  common: {
    cancel: "Annulla",
  },
  arrival: {
    title: "Regole del calendario",
    loading: "Caricamento impostazioni…",
    daysTitle: "Giorni di arrivo e partenza",
    canArrive: "Gli ospiti possono arrivare",
    canDepart: "Gli ospiti possono partire",
    daysHint:
      "Con <b>tutti selezionati</b> non ci sono restrizioni. Se consenti gli arrivi solo di lunedì e le partenze solo di domenica, ogni prenotazione durerà esattamente una settimana.",
    summaryAny: "Gli ospiti possono arrivare e partire qualsiasi giorno",
    summaryArrival: "arrivo in {n} giorni su 7",
    summaryDeparture: "partenza in {n} giorni su 7",
    summaryRestricted: "Limitato: {detail}",
    cutoffTitle: "Chiudi le vendite di oggi dopo un orario prestabilito",
    cutoffToggle: "Chiudi automaticamente le vendite in giornata",
    cutoffToggleHint: "Finché è disattivato, accetti i check-in per oggi a qualsiasi ora.",
    cutoffFrom: "Dalle",
    cutoffTz: "l'ora della tua struttura",
    cutoffTzNow: "lì sono le {time}",
    cutoffHintPre: "Ogni giorno, alle ",
    cutoffHintMid: " a ",
    cutoffHintPost:
      ", smetterai di ricevere prenotazioni per lo stesso giorno. I giorni successivi restano aperti come sempre.",
    cutoffSummaryOn: "Le vendite chiudono ogni giorno alle {time}",
    cutoffSummaryOff: "Accetti i check-in per oggi a qualsiasi ora",
    turnoverTitle: "Tempo di preparazione",
    turnoverQuestion: "Di quante notti hai bisogno tra un ospite e l'altro?",
    turnoverOptNone: "Nessuna",
    nights: "{count} notte | {count} notti",
    custom: "Personalizzato",
    customLabel: "Notti",
    customAside: "per lato, fino a 7",
    turnoverSummaryNone: "Gli ospiti possono arrivare lo stesso giorno in cui un altro parte",
    turnoverSummarySet: "Mantieni {nights} tra un ospite e l'altro",
    turnoverLegacySummaryAfter: "Oggi si applica solo dopo il check-out · salva per coprire entrambi i lati",
    turnoverLegacySummaryBefore: "Oggi si applica solo prima del check-in · salva per coprire entrambi i lati",
    turnoverLegacyNoteAfter: "Questa regola proviene dalla versione precedente e oggi blocca solo dopo il check-out, non prima del check-in. Salvando verrà applicata a entrambi i lati, e prima ti diremo quante notti verranno chiuse.",
    turnoverLegacyNoteBefore: "Questa regola proviene dalla versione precedente e oggi blocca solo prima del check-in, non dopo il check-out. Salvando verrà applicata a entrambi i lati, e prima ti diremo quante notti verranno chiuse.",
    exampleLabel: "Esempio",
    exampleCaption: "Una prenotazione con arrivo il 15 e partenza il 18",
    legendStay: "Soggiorno",
    legendPrep: "Preparazione",
    legendFree: "In vendita",
    turnoverMoveHint:
      "Il blocco si sposta da solo se le date cambiano e scompare se la prenotazione viene annullata.",
    impactClosePre: "Questo chiuderà ",
    impactClosePost: " nei tuoi canali.",
    impactOpenPre: "Questo aprirà ",
    impactOpenPost: ".",
    impactRetry: "Premi di nuovo “Salva regole” per applicarlo.",
    fallbackHost: "la tua struttura",
    saving: "Salvataggio…",
    applyYes: "Sì, applica",
    saveRules: "Salva regole",
    loadError: "Impossibile caricare le impostazioni.",
    saveSuccess: "Regole del calendario salvate e inviate ai tuoi canali.",
    saveError: "Impossibile salvare.",
    saveConfigError: "Impossibile salvare le impostazioni.",
    linkedTitle: "Vendita dell'appartamento intero",
    linkedSummaryOff: "Questa unità si vende da sola",
    linkedSummaryOn: "Vende la casa intera · include {count} camera | Vende la casa intera · include {count} camere",
    linkedSummaryChild: "Fa parte di {parent}",
    linkedRooms: "{count} cam. | {count} cam.",
    linkedToggle: "Imposta come appartamento intero dell'annuncio",
    linkedToggleHint: "Per l'unità che affitta la casa intera. Poi scegli quali camere include.",
    linkedQuestion: "Quali camere include?",
    linkedAll: "Seleziona tutte",
    linkedNone: "Deseleziona tutte",
    linkedIsParent: "Già venduta come appartamento intero",
    linkedGuests: "{count} ospite | {count} ospiti",
    linkedExampleCaption: "Prenotano «{room}» dal 19 al 21",
    linkedExampleRoom: "Camera 1",
    linkedLegendClosed: "Si chiude da sola",
    linkedHint: "E viceversa: se prenotano l'appartamento intero, si chiudono tutte le sue camere. Se la prenotazione viene cancellata o cambia date, tutto si riapre da solo, anche sui tuoi canali. Finché la prenotazione resta valida, queste chiusure non si possono aprire a mano.",
    linkedChildPre: "Questa camera fa parte di ",
    linkedChildPost: ". Se viene prenotata, quell'appartamento intero si chiude per quelle notti; e se prenotano l'appartamento intero, questa camera si chiude da sola. Si modifica dalle regole del calendario dell'appartamento intero.",
    linkedConflicts: "C'è già {count} doppia vendita tra l'appartamento intero e le sue camere. Controllala: | Ci sono già {count} doppie vendite tra l'appartamento intero e le sue camere. Controllale:",
    linkedNeedsRooms: "Seleziona almeno una camera inclusa nell'appartamento intero.",
    linkedSaveError: "Impossibile salvare la vendita dell'appartamento intero.",
    linkedAlertTitle: "«{unit}» diventa l'appartamento intero",
    linkedAlertBody: "Se viene prenotata, le camere che selezioni si chiuderanno automaticamente, qui e sui tuoi canali (Booking, Airbnb…). E se viene prenotata una qualsiasi di esse, questa unità si chiuderà in quelle notti. Se la prenotazione viene cancellata, tutto si riapre da solo.",
    linkedPartialSave: "La vendita dell'appartamento intero è stata salvata, ma non le altre regole. Riprova.",
  },
  weekend: {
    title: "Impostazioni prezzo",
    subtitle: "Queste informazioni verranno mostrate ogni notte, a meno che tu non le personalizzi per data.",
    loading: "Caricamento impostazioni…",
    plTitle: "Prezzi gestiti da PriceLabs",
    plDesc1:
      "Questa struttura ha la gestione dinamica dei prezzi attiva con PriceLabs. I prezzi si aggiornano automaticamente in base a domanda, stagione e occupazione.",
    plDesc2: "Per modificare i prezzi del weekend, fallo direttamente dal tuo pannello PriceLabs.",
    plOpen: "Apri PriceLabs",
    basePriceTitle: "Prezzo base",
    basePriceLabel: "A notte — applicato ogni giorno",
    customization: "Personalizzazione",
    weekendPriceTitle: "Prezzo del weekend",
    toggleOff: "Disattiva il prezzo del weekend",
    toggleOn: "Attiva il prezzo del weekend",
    appliesTo: "Si applica a:",
    weekendLabel: "Weekend",
    infoHint: "Verrà applicato ai prossimi <strong>500 giorni</strong> nei giorni selezionati.",
    disabledText: "I giorni del weekend useranno il prezzo base di",
    confirmTitle: "Disattivare il prezzo del weekend?",
    confirmDescPre: "I giorni torneranno al prezzo base di",
    confirmDescPost: "automaticamente.",
    disabling: "Disattivazione…",
    confirmDisable: "Sì, disattiva",
    saving: "Salvataggio…",
    saveChanges: "Salva modifiche",
    diffEqual: "uguale al base",
    diffUp: "+{pct}% vs base",
    diffDown: "{pct}% vs base",
    loadError: "Errore durante il caricamento delle impostazioni prezzo",
    disableSuccess: "Prezzo del weekend disattivato. I giorni tornano al prezzo base.",
    disableError: "Errore durante la disattivazione del prezzo del weekend",
    saveSuccess: "Prezzi salvati con successo",
    saveError: "Errore durante il salvataggio",
  },
};
